import React from "react";
import PropTypes from "prop-types";
import { CARRIERS } from "MODULES/shared/constants";

export function ShippingPreference({ shippingMethod }) {
  if (!shippingMethod) {
    return null;
  }

  const formattedShippingMethod =
    shippingMethod.carrier &&
    CARRIERS[shippingMethod.carrier] &&
    CARRIERS[shippingMethod.carrier].shippingMethods[
      shippingMethod.shipping_method
    ] &&
    CARRIERS[shippingMethod.carrier].shippingMethods[
      shippingMethod.shipping_method
    ].label;

  return (
    <table className="table table-condensed">
      <tbody>
        <tr>
          <th className="text-right">Carrier</th>
          <td>
            {shippingMethod.carrier &&
              CARRIERS[shippingMethod.carrier] &&
              CARRIERS[shippingMethod.carrier].label}
          </td>
        </tr>
        <tr>
          <th className="text-right">Method</th>
          <td>{formattedShippingMethod || shippingMethod.shipping_method}</td>
        </tr>
        <tr>
          <th className="text-right">Account #</th>
          <td>{shippingMethod.carrier && shippingMethod.account_number}</td>
        </tr>
      </tbody>
    </table>
  );
}

ShippingPreference.propTypes = {
  shippingMethod: PropTypes.shape({
    account_number: PropTypes.string,
    carrier: PropTypes.string,
    shipping_method: PropTypes.string
  })
};



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/ShippingPreference.jsx